<div class="container-fluid px-4 mt-4 mb-5" *ngIf="dataId>0">
    <!-- Page Header -->
    <div class="cp-page-header mb-4">
        <div class="cp-page-title">
            <i class="fa-solid fa-sitemap me-2"></i>
            Editar Dependencia
        </div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a routerLink="/control-ingreso">Control de Ingreso</a></li>
                <li class="breadcrumb-item"><a routerLink="/control-ingreso/dependencias/gestion">Dependencias</a></li>
                <li class="breadcrumb-item active">Editar</li>
            </ol>
        </nav>
    </div>
    <div class="row">
        <div class="col-md-4">
            <div class="card h-100">
                <form novalidate [formGroup]="form" (ngSubmit)="update()">
                    <div class="card-header text-center" style="text-transform: uppercase;">EDITAR DEPENDENCIA</div>
                    <div class="card-body">
                        <form [formGroup]="form" (ngSubmit)="update()">
                            <div class="row gx-3 mb-3">
                                <div class="col-md-12">
                                    <label class="small mb-1" for="name">Razón social (50 max.)</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control text-capitalize" formControlName="name">
                                    </div>
                                </div>

                                <div class="col-md-12">
                                    <label class="small mb-1" for="rut">RUT</label>
                                    <div class="input-group mb-3">
                                        <span class="input-group-text" id="basic-addon1"><i
                                                class="fa-solid fa-id-card"></i></span>
                                        <input (keyup)="onFormatRut($event)" type="text" class="form-control"
                                            formControlName="rut">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label class="small mb-1" for="turn">Giro</label>
                                    <input type="text" class="form-control" formControlName="turn">
                                </div>
                                <div class="col-md-12">
                                    <label class="small mb-1" for="location">Ubicación</label>
                                    <input type="text" class="form-control" formControlName="location">
                                </div>
                                <div class="col-md-12">
                                    <label class="small mb-1" for="rut">INSTALACIÓN</label>
                                    <div class="input-group mb-3">
                                        <span class="input-group-text" id="basic-addon1"><i
                                                class="fa-solid fa-map-location"></i></span>
                                        <select class="form-select" formControlName="facility_id">
                                            <option value="0">SELECCIONE</option>
                                            <option *ngFor="let item of facilitys" [value]="item?.id">{{item?.name}}
                                            </option>
                                        </select>
                                        <button *ngIf="level==1" (click)="openModal(addFacility,'sm')"
                                            class="btn btn-outline-secondary" type="button"><i
                                                class="fa-solid fa-plus"></i></button>
                                    </div>
                                </div>
                                <div class="col-md-12 mb-2 alert alert-warning" *ngIf="level>=99">
                                    <label class="small mb-1" for="hide_rounds">AJUSTES</label>
                                    <div class="form-check form-switch ms-4">
                                        <input class="form-check-input" type="checkbox" (change)="hideRounds($event)"
                                            role="switch" id="hide_rounds"
                                            [checked]="form.get('hide_rounds')?.value==1">
                                        <label class="form-check-label" for="hide_rounds">Ocultar rondas</label>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label class="small mb-1" for="name">Propietario/Gerente (50 max.)</label>
                                    <div class="input-group">
                                        <input type="text" class="form-control text-capitalize" formControlName="owner">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label class="small mb-1" for="name">Telefono Propietario/Gerente</label>
                                    <div class="input-group">
                                        <span class="input-group-text" id="addon-wrapping"><i
                                                class="fa-solid fa-phone"></i></span>
                                        <input type="text" class="form-control text-capitalize"
                                            formControlName="owner_phone">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label class="small mb-1" for="email">Email</label>
                                    <div class="input-group flex-nowrap">
                                        <span class="input-group-text" id="addon-wrapping"><i
                                                class="fa-regular fa-envelope"></i></span>
                                        <input type="email" class="form-control" placeholder="Email  contacto"
                                            formControlName="email">
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <label class="small mb-1" for="phone">Tel.</label>
                                    <div class="input-group flex-nowrap">
                                        <span class="input-group-text" id="addon-wrapping"><i
                                                class="fa-solid fa-phone"></i></span>
                                        <input type="email" class="form-control" placeholder="Telefono contacto"
                                            formControlName="phone">
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                    <div class="card-footer" *ngIf="level>=99">
                        <button class="btn btn-primary w-100" type="submit">GUARDAR CAMBIOS
                        </button>
                    </div>
                </form>
            </div>
        </div>
        <div class="col-md-8">
            <div class="card h-100">
                <div class="card-header">
                    OPCIONES
                    <div class="btn-group float-right" role="group">
                    </div>
                </div>
                <div class="card-body">
                    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
                        <li [ngbNavItem]="1">
                            <a ngbNavLink>PANEL <i class="fa-solid fa-circle-info"></i></a>
                            <ng-template ngbNavContent>
                                <app-information-panel [storesId]="dataId" />
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="2">
                            <a ngbNavLink>ADMINISTRADORES</a>
                            <ng-template ngbNavContent>
                                <app-list-users [storesId]="dataId" />
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="3">
                            <a ngbNavLink>EMPLEADOS/RESIDENTES</a>
                            <ng-template ngbNavContent>
                                <app-list-employees [storesId]="dataId" />
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="4">
                            <a ngbNavLink>PROVEEDORES</a>
                            <ng-template ngbNavContent>
                                <app-list-providers [storesId]="dataId" />
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="5">
                            <a ngbNavLink>VISITANTES</a>
                            <ng-template ngbNavContent>
                                <app-list-visitor [storesId]="dataId" />
                            </ng-template>
                        </li>
                        <li [ngbNavItem]="6">
                            <a ngbNavLink>VEHÍCULOS</a>
                            <ng-template ngbNavContent>
                                <app-list-cars [storesId]="dataId" />
                            </ng-template>
                        </li>
                    </ul>
                    <div [ngbNavOutlet]="nav" class="mt-2"></div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #addFacility let-c="close " let-d="dismiss">
    <div class="modal-body shadow-lg">
        <app-add-facility [refModal]="modalRef" (success)="getFacility(); form.get('facility_id')?.setValue($event)" />
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-warning" aria-label="Close" (click)="d('Cross click')"> Cancelar
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
</ng-template>